import axios from "axios";

axios.defaults.baseURL = "https://movies-tickets-api-production.up.railway.app";
